export class ProjectClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/projects`;
  }

  async homes(id) {
    const url = `${this.baseURL}/${id}/homes`;

    const response = await this.httpClient.request("get", url);

    return response;
  }
}
